import { EprCategoriesResp } from 'types/api/response/epr-categories-resp'

import { api } from './api'

export const getEprCategories = () =>
  api.get<EprCategoriesResp>('/business_accounts/epr_uins/categories')
